import { VehicleWarningItem } from '@/generated/GeneratedApiTypes';

export enum Criticality {
    SCHEDULE_SERVICE = 'SCHEDULE_SERVICE',
    SERVICE_SOON = 'SERVICE_SOON',
    INFORMATION = 'INFORMATION',
}

export interface WarningTag {
    /** Translation key for the tag label. May contain interpolation placeholders (e.g. "Model: {model}"). */
    id: string;
    /** Optional values interpolated into the translation, e.g. { model: 'A210' }. */
    values?: Record<string, string | number>;
}

export interface WarningTags {
    /** Descriptive tag: battery model, or brake-lining axle/side, or the tyre code message. */
    info?: WarningTag;
    /** Status tag, e.g. a brake-lining wear percentage. */
    status?: WarningTag;
}

export interface WarningMessages {
    description: string;
    recommendation: string;
    tags: WarningTags;
}

/** API item enriched with computed `messages`; `criticality` narrowed to the {@link Criticality} enum. */
export type VehicleWarning = Omit<VehicleWarningItem, 'criticality'> & {
    criticality: Criticality;
    messages?: WarningMessages;
};
